import script from "./SelectBrandsStepThree.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBrandsStepThree.vue?vue&type=script&setup=true&lang=js"

import "./SelectBrandsStepThree.vue?vue&type=style&index=0&id=43b13251&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b13251"]])

export default __exports__